export default "__VITE_ASSET__95713b3f__"